export default function PostDetailsScreen() {
  return null;
}
